export default __webpack_public_path__ + "static/roadmap-mobile_es_v2-e0232cabdeb178153484293a7aa1044d.png";